module.exports = __webpack_public_path__ + "static/media/salesRepresentativeIcon.e7025265.svg";